/**
 * LockScreen class definition for webPOS.  Used to interface with Stencil.
 *
 * Copyright 2014 LightSpeed Retail. All rights reserved.
 * Created by kevinford on 15-01-10.
 */

$(() => {
  function LockScreen() {
    window.StencilWebAPI.LockScreenBase.call(this);
  }
  LockScreen.prototype = Object.create(window.StencilWebAPI.LockScreenBase.prototype);
  LockScreen.prototype.constructor = LockScreen;

  /**
   * The native -> web interface called by stencil after a user has been verified
   * throught the stencil lockscreen process.
   *
   * @param {object} - griffinDictionary - object that includes the original args
   * passed to griffin, as well as the pin used by the user to unlock in stencil.
   *   griffingDictionary : {
   *      args: {Array}  -  Args array original sent to griffin,
   *      pin:  {String} -  The pin used by the user to unlock the stencil screen.
   *   }
   */
  LockScreen.prototype.unlockUser = function(griffinDictionary) {
    //Prepare the data object used when calling the verify_pin form.
    var pinLockData = griffinDictionary.args[0] || {};

    pinLockData.form_name = 'verify_pin';
    pinLockData.method = 'POST';

    //The griffin dictionary will include the pin from the user.  Needs to be set
    //under the access_pin key in the data object when calling the verify_pin form.
    pinLockData.access_pin = griffinDictionary.pin;
    window.doServerCall(pinLockData, window.cb_verifypin);
  };

  /**
   * Builds the destination URL for a user,  used by stencil in the event of a
   * user change due to pin verification.  Given current pin lock events, we do
   * not need to specify any specific URL,  but this may change in the future
   *
   *
   * @return {string} - urlPath string of the users attempted destination.
   */
  LockScreen.prototype._getUserDestination = function() {
    return '/';
  };
  window.LockScreen = LockScreen;
});
